import { render, staticRenderFns } from "./VideoEmbed.vue?vue&type=template&id=631f901e&scoped=true&"
import script from "./VideoEmbed.vue?vue&type=script&lang=js&"
export * from "./VideoEmbed.vue?vue&type=script&lang=js&"
import style0 from "./VideoEmbed.vue?vue&type=style&index=0&id=631f901e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631f901e",
  null
  
)

export default component.exports